/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PreBookingConfigDto } from './PreBookingConfigDto';
import {
    PreBookingConfigDtoFromJSON,
    PreBookingConfigDtoFromJSONTyped,
    PreBookingConfigDtoToJSON,
} from './PreBookingConfigDto';

/**
 * 
 * @export
 * @interface PreBookingUiConfigRtoV2
 */
export interface PreBookingUiConfigRtoV2 {
    /**
     * 
     * @type {PreBookingConfigDto}
     * @memberof PreBookingUiConfigRtoV2
     */
    prebookingConfigData: PreBookingConfigDto;
    /**
     * 
     * @type {string}
     * @memberof PreBookingUiConfigRtoV2
     */
    optionIconBaseUrl: string;
}

/**
 * Check if a given object implements the PreBookingUiConfigRtoV2 interface.
 */
export function instanceOfPreBookingUiConfigRtoV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "prebookingConfigData" in value;
    isInstance = isInstance && "optionIconBaseUrl" in value;

    return isInstance;
}

export function PreBookingUiConfigRtoV2FromJSON(json: any): PreBookingUiConfigRtoV2 {
    return PreBookingUiConfigRtoV2FromJSONTyped(json, false);
}

export function PreBookingUiConfigRtoV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): PreBookingUiConfigRtoV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prebookingConfigData': PreBookingConfigDtoFromJSON(json['prebookingConfigData']),
        'optionIconBaseUrl': json['optionIconBaseUrl'],
    };
}

export function PreBookingUiConfigRtoV2ToJSON(value?: PreBookingUiConfigRtoV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prebookingConfigData': PreBookingConfigDtoToJSON(value.prebookingConfigData),
        'optionIconBaseUrl': value.optionIconBaseUrl,
    };
}

